<template>
  <b-modal
    id="modal-operadora"
    ref="#btnShowOperadora"
    size="md"
    @show="showModalOperadora"
    @hidden="resetModalOperadora"
    @ok="handleOkOperadora"
    ok-only
    ok-variant="warning"
    ok-title="Confirmar1"
    scrollable
    hide-footer>
    <template v-slot:modal-title>
     + PLANOS
    </template>
    <div class="d-block text-center">
      <div class="row">
        <div class="col-6 text-left">
          <b-form-group class="p-0 m-0">
            <b-form-radio-group
              id="tipo_planos"
              v-model="filtros.tipo_plano"
              :options="tipo_planos"
              buttons
              name="radios-btn-default"
              size="sm"
              label-size="sm"
              button-variant="primary"
            ></b-form-radio-group>
          </b-form-group>
        </div>
        <div class="col-6 text-right">
          <b-form-group class="p-0 m-0">
            <b-form-radio-group
              id="contratacoes"
              v-model="filtros.contratacao"
              :options="contratacoes"
              buttons
              name="radios-btn-default"
              size="sm"
              button-variant="primary"
            ></b-form-radio-group>
          </b-form-group>
        </div>
      </div>
      <div class="row mt-2 mb-2">
        <div class="col-12">
          <v-select id="profissoes"
            v-model="filtros.entidade_profissao"
            :filterable="false"
            :options="entidades_profissoes"
            :selected="filtros.entidade_profissao"
            @search="onSearchProfissao"
            :selectable="option => !option.hasOwnProperty('group')"
            label="nome"
            placeholder="Profissão ou Entidade de Classe"
            class="mt-2 mb-2"
            v-if="filtros.contratacao == 'a'">
            <template slot="no-options">Profissão ou Entidade de Classe não localizada</template>
            <template #option="{ nome, descricao }">
              {{ nome }} <template v-if="descricao">- {{ descricao }}</template>
            </template>
          </v-select>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <b-form-group
            id="busca"
            label-for="busca-input"
            label-align="left"
          >
            <b-form-input
              id="busca-input"
              type="email"
              v-model="busca"
              placeholder="Pesquisar..."
              class="m-0"
            />
          </b-form-group>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="card-container" v-if="operadoras.length">
            <div
              class="card card-logo"
              v-for="operadora in search"
              :key="operadora.id"
            >
              <div class="content"
                @click="openModalOperadora(operadora)">
                <img :src="operadoraLogoTipo(operadora)"
                  :alt="operadora.nome"
                  style="max-height: 100%;" />
              </div>
            </div>
          </div>
          <p v-else-if="!loadingOperadoras" class="text-center h5 mt-4">
            <i class="ti-info-alt h4"></i> <br />
            Nenhum registro encontrado! <br />
            Por favor, verifique as opções de filtro e tente novamente.
          </p>
          <div class="text-center">
            <loader :width="'150px'" :height="'150px'" v-if="loadingOperadoras" />
          </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import lodash from "lodash";
import { mapActions, mapGetters } from "vuex"
import Loader from "@/components/Loader";
import Diff from "@/components/Diff";

export default {
  data() {
    return {
      open: false,
      busca: "",
      tipo_planos: [
        { text: 'Saúde', value: 's' },
        { text: 'Odonto', value: 'o' }
      ],
      contratacoes: [
        { text: 'PF', value: 'pf' },
        { text: 'PME', value: 'pme' },
        { text: 'Adesão', value: 'a' }
      ],
      lista_adesao: [
        { text: 'Administradora', value: 'a' },
        { text: 'Entidade', value: 'e' },
        { text: 'Profissão', value: 'p' },
      ],
      entidades_profissoes: []
    }
  },
  mixins: [Diff],
  computed: {
    ...mapGetters("share", {
      filtros: "getFiltros"
    }),
    ...mapGetters("operadora", {
      operadoras: "getOperadoras",
      operadora: "getOperadora",
      loadingOperadoras: "getLoadingOperadoras"
    }),
    ...mapGetters("profissao", {
      profissoes: "getProfissoes",
      loadingProfissoes: "getLoading"
    }),
    ...mapGetters("cenario", {
      cenario: "getCenario",
      cenarios: "getCenarios"
    }),
    search() {
      const self = this;
      return this.operadoras.filter((operadora) => {
        let term = self.busca.replace(/[\s]/, ".*");
        return operadora.nome.search(new RegExp("(" + term + ")", "ig")) != -1;
      });
    },
    parseCompulorio() {
      return this.filtros.compulsorio == 2
        ? ""
        : this.filtros.compulsorio == 1
        ? "s"
        : "n"
    },
    parseCoparticipacao() {
      return this.filtros.coparticipacao == 2
        ? ""
        : this.filtros.coparticipacao == 1
        ? "s"
        : "n"
    },
    parseRegrasAceitacao() {
      return this.filtros.regras_aceitacao
        ? "s"
        : "n"
    },
    parseAcomodacao() {
      return this.filtros.acomodacao == 2
        ? ""
        : this.filtros.acomodacao == 1
        ? "a"
        : "e"
    },
    parseCredenciado() {
      return this.filtros.credenciado
        ? this.filtros.credenciado.tipo + this.filtros.credenciado.id
        : ""
    },
    parseProfissao() {
      return this.filtros.entidade_profissao?.tipo == 'p'
        ? this.filtros.entidade_profissao.value.id
        : ''
    },
    parseEntidade() {
      return this.filtros.entidade_profissao?.tipo == 'e'
        ? this.filtros.entidade_profissao.value.id
        : ''
    },
    parseMei() {
      return this.filtros.mei == 2
        ? ""
        : this.filtros.mei == 1
        ? "s"
        : "n"
    }
  },
  watch: {
    filtros: {
      deep: true,
      handler() {
        if (this.open) {
          this.onSearchOperadoras(true);
        }
      },
    },
  },
  methods: {
    ...mapActions("operadora", [
      "buscaOperadora",
      "resetOperadora",
      "resetOperadoras",
      "resetPlano",
      "resetProduto",
      "resetAdministradora",
      "resetEntidade",
      "selectedOperadora",
    ]),
    ...mapActions(
      "produto", [
        "resetProdutos",
      ]
    ),
    ...mapActions(
      "plano", [
        "resetPlanos",
        "resetGrupos",
        "resetGrupoTree",
        "resetPlanosPorRede",
        "resetValores"
      ]
    ),
    ...mapActions('profissao', [
      "buscaProfissao",
      "resetProfissao"
    ]),
    openModalOperadora(operadora) {
      this.selecionaOperadora(operadora)
    },
    operadoraLogoTipo(operadora) {
      return operadora.logotipoavo ? operadora.logotipoavo : operadora.logotipo;
    },
    async onSearchOperadoras(clear) {
      console.log('ModalOperadora::onSearchOperadoras()');
      if (clear) {
        await this.resetOperadora();
        await this.resetOperadoras();
        await this.resetProduto();
        await this.resetAdministradora();
        await this.resetEntidade();
        await this.resetProdutos();
        await this.resetPlanos();
        await this.resetGrupos();
        await this.resetGrupoTree();
        await this.resetPlanosPorRede();
        await this.resetValores();
        await this.resetProfissao();
        this.busca = "";
      }
      if (this.operadoras.length == 0) {
        await this.searchOperadoras(this);
      }
    },
    validateDiff(oldFiltros, filtros) {
      let validate_keys = ["tipo_plano", "contratacao", "entidade_profissao"];
      let diff = this.diff(oldFiltros, filtros);
      let diff_key = Object.keys(diff).shift();
      return diff_key ? validate_keys.indexOf(diff_key) != -1 : false;
    },
    searchOperadoras: _.debounce(async (vm) => {
      if (vm.filtros.cidade && vm.filtros.contratacao) {
        await vm.buscaOperadora({
          uf: vm.filtros.cidade.uf,
          tipo_plano: vm.filtros.tipo_plano,
          contratacao: vm.filtros.contratacao,
          cidade: vm.filtros.cidade ? vm.filtros.cidade.id : "",
          compulsorio: vm.parseCompulorio,
          coparticipacao: vm.parseCoparticipacao,
          acomodacao: vm.parseAcomodacao,
          regras_aceitacao: vm.parseRegrasAceitacao,
          credenciado: vm.parseCredenciado,
          entidade: vm.parseEntidade,
          profissao: vm.parseProfissao,
          faixas: vm.cenario?.faixas ? vm.cenario.faixas : "",
          grupos_faixas: vm.totalVidas(vm.cenarios),
          mei: vm.parseMei
        })
      }
    }, 500),
    totalVidas(cenarios) {
      var grupos_faixas = [];
      cenarios.forEach(cenario => {
        cenario.faixas.forEach(faixa => {
          let key = grupos_faixas.findIndex(gf => gf.slug == faixa.slug)
          if (key != -1) {
            grupos_faixas[key].value = parseInt(grupos_faixas[key].value||0) + parseInt(faixa.value||0);
          } else {
            grupos_faixas.push(JSON.parse(JSON.stringify(faixa)));
          }
        })
      });
      return grupos_faixas
    },
    onSearchProfissao(search, loading) {
      if (search && search.length >= 3) {
        loading(false)
        this.searchProfissao(loading, search, this)
      }
    },
    searchProfissao: _.debounce(async (loading, search, vm) => {
      vm.entidades_profissoes = []
      await vm.buscaProfissao({
        uf: vm.filtros.cidade.uf,
        cidade: '', // vm.filtros.cidade.id,
        search: search
      })

      vm.entidades_profissoes = vm.profissoes.map(r => {
        return {
          tipo: r.tipo,
          nome: r.nome,
          descricao: r?.descricao,
          value: r
        }
      })
      loading(vm.loadingProfissoes)
    }, 500),
    resetModalOperadora() {
      this.open = false;
    },
    showModalOperadora() {
      console.log('ModalOperadora::showModalOperadora()');
      this.open = true;
      this.onSearchOperadoras(true)
    },
    handleOkOperadora() {},
    handleSubmitOperadora() {},
    selecionaOperadora(operadora) {
      operadora.filtros = JSON.parse(JSON.stringify(this.filtros));
      operadora.grupos = []
      this.selectedOperadora(operadora)
      this.resetPlano();
      if (this.filtros.contratacao == 'a') {
        this.$bvModal.show('modal-produtos-adesao')
      } else {
        this.$bvModal.show('modal-produtos')
      }
    },
  },
  components: {
    Loader
  }
}
</script>

<style>

</style>
